import { Globe } from 'lucide-react'

interface Props {
  appName: string
}

export default function Home({ appName }: Props) {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-sm rounded-xl border p-8 text-center shadow-sm">
        <span className="bg-primary text-primary-foreground mx-auto flex size-10 items-center justify-center rounded-lg">
          <Globe className="size-5" />
        </span>
        <h1 className="mt-4 text-[26px] font-semibold leading-tight">{appName}</h1>
        <p className="text-muted-foreground mt-2 text-sm">
          In-house website builder — control plane. Sign in through the Growbotik vendor
          dashboard (&ldquo;Open Website Builder&rdquo;).
        </p>
      </div>
    </main>
  )
}
